import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { ItemList } from '../components/ItemList.js';

const OptInsContainer = ({ isLoggedIn , isCreateAccountEnabled , onChange , selectedOptIns , optIns , isImplicitAccountCreation , isMyAccountEnabled  })=>{
    const { getFormattedLabel  } = useIntl();
    const getItemLabel = React.useCallback((item)=>getFormattedLabel(item.titleKey, {
            parseHTML: true
        })
    , [
        getFormattedLabel
    ]);
    const shouldIndent = React.useMemo(()=>!isLoggedIn && isCreateAccountEnabled && !isImplicitAccountCreation
    , [
        isImplicitAccountCreation,
        isLoggedIn,
        isCreateAccountEnabled
    ]);
    const getItemIdentifier = React.useCallback((item)=>item.titleKey
    , []);
    /**
   * Do not display opt-ins on these conditions:
   * 1. My account disabled and no custom opt-ins provided from an opco
   * 2. Displayable opt-ins list is empty
   * 3. Customer is not logged in and the create account check mark is not checked
   */ if (!optIns.length || isMyAccountEnabled && !isLoggedIn && !isCreateAccountEnabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ItemList, {
        getItemIdentifier: getItemIdentifier,
        getItemLabel: getItemLabel,
        idPrefix: "opt-ins__",
        items: optIns,
        onChange: onChange,
        selectedItems: selectedOptIns,
        shouldIndent: shouldIndent
    });
};

export { OptInsContainer };
//# sourceMappingURL=OptInsContainer.js.map
